import { Shield, Users, X, ChevronLeft, ChevronRight } from "lucide-react"
import { useCommunity } from "../../context/CommunityContext"

const communityData = {
  memberCount: 1234,
  admins: [
    { id: 1, name: "John Doe", avatar: "/placeholder.svg?height=40&width=40", role: "Founder" },
    { id: 2, name: "Jane Smith", avatar: "/placeholder.svg?height=40&width=40", role: "Admin" },
  ],
  activeMembers: [
    { id: 3, name: "Alice Johnson", avatar: "/placeholder.svg?height=40&width=40", status: "Writing a post..." },
    { id: 4, name: "Bob Wilson", avatar: "/placeholder.svg?height=40&width=40", status: "Online" },
    { id: 5, name: "Carol Brown", avatar: "/placeholder.svg?height=40&width=40", status: "Online" },
  ],
}

export default function CommunitySidebar({
  isOpen,
  isMobileOpen,
  onMobileClose,
  onToggle,
}) {

  const communityCtx = useCommunity();

  return (
    <aside
      className={`
        fixed lg:relative inset-y-0 right-0 z-40
        flex flex-col
        bg-white
        border-l border-gray-200
        transition-all duration-300 ease-in-out
        ${isOpen ? "w-[300px]" : "w-[80px]"}
        ${isMobileOpen ? "translate-x-0" : "translate-x-full lg:translate-x-0"}
      `}
    >
      {/* Collapse button */}
      <button
        onClick={onToggle}
        className="hidden lg:flex absolute -left-4 top-8 z-50 w-8 h-8 bg-white border border-gray-200 rounded-full items-center justify-center hover:bg-gray-50 transition-colors"
      >
        {isOpen ? <ChevronRight className="w-5 h-5" /> : <ChevronLeft className="w-5 h-5" />}
      </button>

      {/* Mobile close button */}
      <button
        onClick={onMobileClose}
        className="lg:hidden absolute top-4 left-4 p-2 rounded-lg hover:bg-gray-100"
      >
        <X className="w-5 h-5" />
      </button>

      <div className="flex-1 flex flex-col min-h-0">
        {/* Community Admins */}
        {/* <div className="p-6 border-b border-gray-200">
          <div className="flex items-center gap-2 mb-4">
            <Shield className="w-5 h-5 text-indigo-600 flex-shrink-0" />
            <h2 className={`font-semibold ${!isOpen && "lg:hidden"}`}>Community Staff</h2>
          </div>
          <div className="space-y-4">
            {communityData.admins.map((admin) => (
              <div key={admin.id} className="flex items-center gap-3">
                <img
                  src={admin.avatar || "/placeholder.svg"}
                  alt={admin.name}
                  className="w-10 h-10 rounded-full flex-shrink-0"
                />
                {isOpen && (
                  <div className="hidden lg:block min-w-0">
                    <p className="font-medium truncate">{admin.name}</p>
                    <p className="text-sm text-indigo-600 truncate">{admin.role}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div> */}

        {/* Active Members */}
        <div className="flex-1 overflow-y-auto p-6 border-b border-gray-200">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <Users className="w-5 h-5 text-green-600 flex-shrink-0" />
              <h2 className={`font-semibold ${!isOpen && "lg:hidden"}`}>Active Now</h2>
            </div>
            {isOpen && (
              <span className="text-sm text-gray-500 hidden lg:block">{((communityCtx.members ? communityCtx.members.data.members : []) || []).length}</span>
            )}
          </div>
          <div className="space-y-4">
            {((communityCtx.members ? communityCtx.members.data.members : []) || []).map((member) => (
              <div key={member.id} className="flex items-center gap-3">
                <div className="relative flex-shrink-0">
                  <img src={member.profilePicture || "/placeholder.svg"} alt={member.name} className="w-10 h-10 rounded-full" />
                  <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></span>
                </div>
                {isOpen && (
                  <div className="hidden lg:block min-w-0">
                    <p className="font-medium truncate">{member.name}</p>
                    <p className="text-sm text-gray-500 truncate">{member.status}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Community Stats */}
        {isOpen && (
          <div className="p-6 hidden lg:block">
            <h2 className="font-semibold mb-4">Community Stats</h2>
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <span className="text-gray-600">Total Members</span>
                <span className="font-semibold">{communityCtx.community.community.memberCount}</span>
              </div>
              {/* <div className="flex justify-between items-center">
                <span className="text-gray-600">Online</span>
                <span className="font-semibold">{communityData.activeMembers.length}</span>
              </div> */}
              {/* <div className="flex justify-between items-center">
                <span className="text-gray-600">Posts Today</span>
                <span className="font-semibold">24</span>
              </div> */}
            </div>
          </div>
        )}
      </div>
    </aside>
  )
}

